export default "__VITE_ASSET__DgDkPkvp__"